module.exports = __webpack_public_path__ + "views/delete.245f3a6206025837177eb98952cba591.html";